/* =============================================================
   PawShift — ps-cart-drawer.js
   AJAX cart drawer · open/close · fetch cart · render items
   ============================================================= */

(function () {
  'use strict';

  /* ── DOM refs ── */
  var drawer   = document.getElementById('ps-cart-drawer');
  var overlay  = document.getElementById('ps-cd-overlay');
  var closeBtn = document.getElementById('ps-cd-close');
  var itemsEl  = document.getElementById('ps-cd-items');
  var emptyEl  = document.getElementById('ps-cd-empty');
  var footerEl = document.getElementById('ps-cd-footer');
  var subtotal = document.getElementById('ps-cd-subtotal');
  var shipFill = document.getElementById('ps-cd-ship-fill');
  var shipText = document.getElementById('ps-cd-ship-text');
  var shipZone = document.getElementById('ps-cd-ship-zone');

  if (!drawer) return; // snippet not rendered — bail

  var threshold = parseInt(drawer.getAttribute('data-threshold') || '7500', 10);

  /* ─────────────────────────────────────────
     Open / Close
  ───────────────────────────────────────── */
  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-active');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ps-cd-open');
    closeBtn.focus();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-active');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ps-cd-open');
  }

  /* ─────────────────────────────────────────
     Money formatter
  ───────────────────────────────────────── */
  var _moneyFmt = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: (window.PS_DATA && window.PS_DATA.currencyCode) || 'AUD',
    minimumFractionDigits: 0, maximumFractionDigits: 0
  });
  function money(cents) { return _moneyFmt.format(cents / 100); }

  /* ─────────────────────────────────────────
     Free shipping bar
  ───────────────────────────────────────── */
  function updateShipping(cart) {
    var items = cart.items || [];
    var mainItems = items.filter(function (it) {
      return !(it.properties && it.properties['_gift'] === '1');
    });

    // Free shipping is tier-based (qty >= 2), NOT a subscription perk —
    // mirrors the PDP giftEligibility() rule (shipping = selectedTier > 1).
    var hasFreeShip = mainItems.some(function (it) {
      return it.quantity >= 2;
    });

    if (hasFreeShip) {
      shipFill.style.width = '100%';
      shipFill.classList.add('is-unlocked');
      shipZone.classList.add('is-unlocked');
      shipText.textContent = '✓ FREE SHIPPING UNLOCKED';
    } else {
      var totalJars = mainItems.reduce(function (sum, it) { return sum + it.quantity; }, 0);
      var pct = Math.min(100, (totalJars / 2) * 100);
      var jarsNeeded = 2 - totalJars;
      shipFill.style.width = pct + '%';
      shipFill.classList.remove('is-unlocked');
      shipZone.classList.remove('is-unlocked');
      shipText.textContent = jarsNeeded <= 1
        ? 'ADD 1 MORE JAR FOR FREE SHIPPING'
        : 'ADD ' + jarsNeeded + ' MORE JARS FOR FREE SHIPPING';
    }
  }

  /* ─────────────────────────────────────────
     Render a single item row
  ───────────────────────────────────────── */
  var TRASH_SVG = '<svg viewBox="0 0 24 24" stroke-width="1.75" stroke-linecap="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4h6v2"/></svg>';

  // Gift display copy — keeps the cart congruent with the PDP free-gift tiles
  // (name + one-line descriptor). Keyed off the VARIANT ID, not the product
  // title: the hoodie is titled "Ear cover for loud moments", so a title
  // substring test for "hoodie" fell through and gave the hoodie line the
  // ebook's name and description. Only two gift products exist.
  var GIFT_META = {
    hoodie: {
      name: 'Ear cover for loud moments',
      desc: 'A bit of outside comfort for loud moments — while the protocol settles their baseline underneath.'
    },
    ebook: {
      name: 'Science-based settling guide',
      desc: 'A digital guide to the settling process — what to expect, and how to get the most from the protocol.'
    }
  };
  function giftMeta(item) {
    var hoodieId = (window.PS_DATA && String(window.PS_DATA.giftHoodie)) || '48337799708913';
    var isHoodie = String(item.id) === hoodieId ||
                   String(item.variant_id) === hoodieId ||
                   /hoodie|ear cover|snood|ear muff/.test(String(item.product_title || '').toLowerCase());
    return isHoodie ? GIFT_META.hoodie : GIFT_META.ebook;
  }

  function itemHTML(item) {
    var props = item.properties || {};
    var isGift = props['_gift'] === '1';

    var name = item.product_title || 'Item';
    // 3x source for a 72px CSS box — retina screens upscaled the old _72x72.
    var imgSrc = item.image ? item.image.replace(/(\.[^.]+)$/, '_216x216_crop_center$1') : '';
    var imgTag = imgSrc ? '<img src="' + imgSrc + '" alt="' + escapeHtml(name) + '" loading="lazy">' : '';

    if (isGift) {
      var meta = giftMeta(item);
      var giftName = meta.name;
      var compareAt = parseInt(props['_compare_at'] || '0', 10);
      var priceHtml = compareAt > 0
        ? '<s class="ps-cd__item-strike">' + money(compareAt) + '</s><span class="ps-cd__item-price is-free">FREE</span>'
        : '<span class="ps-cd__item-price is-free">FREE</span>';
      return (
        '<div class="ps-cd__item ps-cd__item--gift" data-line="' + item.line + '">' +
          '<div class="ps-cd__item-top">' +
            '<div class="ps-cd__item-img">' + imgTag + '</div>' +
            '<div class="ps-cd__item-info">' +
              '<p class="ps-cd__item-title">' + escapeHtml(giftName) + '</p>' +
              '<p class="ps-cd__item-meta ps-cd__gift-label">FREE GIFT</p>' +
              '<p class="ps-cd__item-desc">' + escapeHtml(meta.desc) + '</p>' +
            '</div>' +
            '<div class="ps-cd__item-right">' + priceHtml + '</div>' +
          '</div>' +
          '<div class="ps-cd__item-actions ps-cd__item-actions--gift">' +
            '<button class="ps-cd__item-remove" data-line="' + item.line + '" aria-label="Remove ' + escapeHtml(giftName) + '">' + TRASH_SVG + '</button>' +
          '</div>' +
        '</div>'
      );
    }

    var jars = item.quantity;
    // Supply in days, from the dose carried on the line by ps-hero-2. Math.floor
    // must match calcDays() there so the cart and the PDP never disagree
    // (200/3 = 66 days, not 67). No dose => the old chew count.
    var dose = parseInt((item.properties || {})['_dose'] || '0', 10);
    var supply = dose > 0
      ? Math.floor(jars * 100 / dose) + ' days'
      : (jars * 100) + ' chews';
    var hasSub = item.selling_plan_allocation != null;
    // A selling plan SETS the price, so Shopify reports original_line_price ===
    // final_line_price (no "discount"). To show the true subscription saving we
    // compare against the plan's pre-discount price (compare_at_price × qty).
    var trueOriginal = item.original_line_price;
    if (hasSub && item.selling_plan_allocation.compare_at_price) {
      trueOriginal = item.selling_plan_allocation.compare_at_price * jars;
    }
    var hasSavings = trueOriginal > item.final_line_price;
    var subBadge = hasSub ? '<span class="ps-cd__item-sub-badge">Subscribe &amp; Save</span>' : '';
    var priceBlock =
      (hasSavings ? '<s class="ps-cd__item-strike">' + money(trueOriginal) + '</s>' : '') +
      '<span class="ps-cd__item-price">' + money(item.final_line_price) + '</span>' +
      (hasSavings ? '<span class="ps-cd__item-save">Save ' + money(trueOriginal - item.final_line_price) + '</span>' : '') +
      subBadge;

    // Free shipping is tier-based (qty >= 2), NOT a subscription perk — mirrors
    // the PDP rule giftEligibility(): shipping = selectedTier > 1. A single-jar
    // subscription (e.g. small dog) does NOT get free shipping.
    var shipNote = (jars >= 2)
      ? '<span class="ps-cd__item-ship-benefit is-free">Free shipping</span>'
      : '';

    return (
      '<div class="ps-cd__item" data-line="' + item.line + '" data-qty="' + jars + '">' +
        '<div class="ps-cd__item-top">' +
          '<div class="ps-cd__item-img">' +
            imgTag +
            '<span class="ps-cd__item-jar-badge">×' + jars + '</span>' +
          '</div>' +
          '<div class="ps-cd__item-info">' +
            '<p class="ps-cd__item-title">' + escapeHtml(name) + '</p>' +
            '<p class="ps-cd__item-meta">' + jars + ' jar' + (jars !== 1 ? 's' : '') + ' · ' + supply + '</p>' +
            shipNote +
          '</div>' +
          '<div class="ps-cd__item-right">' + priceBlock + '</div>' +
        '</div>' +
        '<div class="ps-cd__item-actions">' +
          '<div class="ps-cd__qty">' +
            '<button class="ps-cd__qty-btn" data-line="' + item.line + '" data-dir="down" aria-label="Decrease quantity">−</button>' +
            '<span class="ps-cd__qty-num">' + jars + '</span>' +
            '<button class="ps-cd__qty-btn' + (jars >= 3 ? ' is-max' : '') + '" data-line="' + item.line + '" data-dir="up" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<button class="ps-cd__item-remove" data-line="' + item.line + '" aria-label="Remove ' + escapeHtml(name) + '">' + TRASH_SVG + '</button>' +
        '</div>' +
      '</div>'
    );
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ─────────────────────────────────────────
     Render cart state
  ───────────────────────────────────────── */
  function renderCart(cart) {
    var items = cart.items || [];
    var hasItems = items.length > 0;

    // Assign Shopify line numbers BEFORE sorting — qty/remove buttons rely on
    // item.line matching the real cart index.
    items.forEach(function (item, i) { item.line = i + 1; });

    // Display order: main product on top, then Calming Hoodie, then E-Book.
    // (Sort a copy; line numbers stay correct. Array.sort is stable, so items
    // of the same rank keep their original order.)
    function sortRank(item) {
      var isGift = item.properties && item.properties['_gift'] === '1';
      if (!isGift) return 0;
      var title = (item.product_title || '').toLowerCase();
      if (title.indexOf('hoodie') !== -1) return 1;
      return 2;
    }
    var orderedItems = items.slice().sort(function (a, b) {
      return sortRank(a) - sortRank(b);
    });

    if (hasItems) {
      itemsEl.innerHTML = orderedItems.map(itemHTML).join('');
      emptyEl.style.display = 'none';
      itemsEl.style.display = '';
      footerEl.style.display = '';

      var totalStr = money(cart.total_price);
      subtotal.textContent = totalStr;

      // Checkout button label stays as "Secure Checkout" (icon + text set in Liquid)

      // Hide "taxes & shipping" note when all items have free shipping
      var footerNote = document.getElementById('ps-cd-footer-note');
      if (footerNote) {
        var mainItems = items.filter(function (it) { return !(it.properties && it.properties['_gift'] === '1'); });
        var hasFreeShip = mainItems.some(function (it) { return it.quantity >= 2; });
        footerNote.style.display = hasFreeShip ? 'none' : '';
      }
    } else {
      itemsEl.innerHTML = '';
      itemsEl.style.display = 'none';
      emptyEl.style.display = '';
      footerEl.style.display = 'none';
    }

    updateShipping(cart);
  }

  /* ─────────────────────────────────────────
     Fetch cart from API
  ───────────────────────────────────────── */
  function fetchAndRender(andOpen) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        if (andOpen) openDrawer();
      })
      .catch(function (e) {
        console.error('[ps-cart-drawer] fetch error:', e);
      });
  }

  /* ─────────────────────────────────────────
     Update line item quantity
  ───────────────────────────────────────── */
  function updateLine(line, qty) {
    var updates = {};
    updates[line] = qty;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function (e) {
        console.error('[ps-cart-drawer] update error:', e);
      });
  }

  /* ─────────────────────────────────────────
     Event: qty buttons + remove (delegated)
  ───────────────────────────────────────── */
  itemsEl.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line]');
    if (!btn) return;

    var line = parseInt(btn.getAttribute('data-line'), 10);

    if (btn.classList.contains('ps-cd__item-remove')) {
      updateLine(line, 0);
      return;
    }

    if (btn.classList.contains('ps-cd__qty-btn')) {
      var itemEl = btn.closest('.ps-cd__item');
      if (!itemEl || itemEl.classList.contains('ps-cd__item--gift')) return;
      var currentQty = parseInt(itemEl.getAttribute('data-qty') || '1', 10);
      var dir = btn.getAttribute('data-dir');
      if (dir === 'up') {
        if (currentQty >= 3) return;
        updateLine(line, currentQty + 1);
      } else {
        if (currentQty <= 1) updateLine(line, 0);
        else updateLine(line, currentQty - 1);
      }
    }
  });

  /* ─────────────────────────────────────────
     Event: close triggers
  ───────────────────────────────────────── */
  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  /* ─────────────────────────────────────────
     Event: cart icon click — open + refresh
  ───────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var cartLink = e.target.closest('a[href="/cart"]');
    if (!cartLink) return;
    // Only intercept if it's in the header/nav area (not checkout links)
    var isInNav = cartLink.closest('header, .header, .ps-header, .site-header, .sticky-bar, .ps-hero__sticky');
    if (!isInNav) return;
    e.preventDefault();
    fetchAndRender(true);
  });

  /* ─────────────────────────────────────────
     Event: cart:refresh — fired by ps-hero-2
  ───────────────────────────────────────── */
  document.addEventListener('cart:refresh', function () {
    fetchAndRender(true);
  });

  document.addEventListener('cart:updated', function () {
    fetchAndRender(false);
  });

  /* ─────────────────────────────────────────
     Init — hide footer/items zones until cart loaded
  ───────────────────────────────────────── */
  footerEl.style.display = 'none';
  itemsEl.style.display = 'none';

})();
